var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFadedDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45898 20.2905V23.1105C7.46005 23.4841 7.61008 23.8422 7.87629 24.1064C8.14251 24.3706 8.50326 24.5195 8.87975 24.5205H18.8241C19.2009 24.5205 19.5623 24.372 19.8287 24.1075C20.0952 23.8431 20.2448 23.4845 20.2448 23.1105V20.2905M17.4033 16.0605L13.8524 19.5855L10.3005 16.0605M13.8524 18.7395V11.4785",
    stroke: "#939AA8",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.732422,
    width: 26.7049,
    height: 34.535,
    rx: 5.5,
    stroke: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadedDownloadIcon);
export default __webpack_public_path__ + "static/media/fadedDownloadIcon.5672c84a6acda81308d99f3f64ef2980.svg";
export { ForwardRef as ReactComponent };